// services/everpro/everpro-shipping/bulkRates.ts — Get Bulk Logistic Rates per-brand via S2 proxy
// Endpoint: POST /shipment/v2/bulk/rates { data: [BulkGetRatesData] } — tiap item = payload rates
// tunggal + client_order_no. Respon: data[] = { client_order_no, error_message, rates }.
import { withRetry } from '../../../utils/retryLogic';
import { everproFetch } from '../everpro-auth';
import type { EverproRatesData, GetRatesParams } from '../everpro-types';
import { buildRatesBody } from './rates/body.js';

export interface BulkRateRequestItem extends GetRatesParams {
  clientOrderNo: string;
}

export interface BulkRateResultItem {
  clientOrderNo?: string;
  errorMessage?: string;
  rates: EverproRatesData;
}

export async function fetchBulkShippingRates(
  items: BulkRateRequestItem[],
  brandId: string,
): Promise<BulkRateResultItem[]> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  if (!items.length) return [];

  const data = items.map(it => ({
    ...buildRatesBody(it),
    client_order_no: it.clientOrderNo,
  }));

  const res = await withRetry(() => everproFetch(brandId, '/shipment/v2/bulk/rates', {
    method: 'POST',
    body: JSON.stringify({ data }),
  }), {
    maxRetries: 2,
    initialDelayMs: 1000,
    backoffMultiplier: 2,
    shouldRetry: (err) => err instanceof TypeError,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro bulk rates: ${res.status} ${res.statusText}${detail ? ' – ' + detail.slice(0, 120) : ''}`);
  }

  const json = await res.json();
  // Response asli (sandbox): { data: { success_count, failed_count, success: [{ client_order_no, rates }] } }
  // — BUKAN array di data seperti swagger. Toleransi kedua format.
  const d = json?.data ?? {};
  const list = Array.isArray(d) ? d : (Array.isArray(d?.success) ? d.success : []);
  return list.map((it: any) => ({
    clientOrderNo: it.client_order_no,
    errorMessage: it.error_message || '',
    rates: (it.rates ?? {}) as EverproRatesData,
  }));
}
